import { OdooModel } from './odoo-model.model';
import { OdooSerializableInterface } from '../shared/interfaces/odoo-serializable-interface';
import { OdooMultiRelationship } from './odoo-multi-relationship.model';

export class User extends OdooModel implements OdooSerializableInterface<User> {
  public readonly ODOO_MODEL = 'res.users';

  id: number;
  name: string;


  constructor(id?: number, name?: string) {
    super(id);
    this.id = id;
    this.name = name;
  }

  create(): User {
    return new User();
  }
}
